export const marketplaceData = [
    {
        first : "Market Cap",
        value1 : '$250,200,874.41',
        second : "Circulating Supply",
        value2 : "1,283,377,592",
        bgColor : "linear-gradient(270deg, rgba(184, 163, 234, 0.66) 0%, rgba(148, 116, 221, 0.66) 100%)"
    },
    {
        first : "TITANO Price",
        value1 : '$0.1950',
        second : "Backed Liquidity",
        value2 : "0%",
        bgColor : "linear-gradient(270deg, rgba(136, 234, 207, 0.66) 0%, rgba(48, 189, 150, 0.66) 100%)"
    },
    {
        first : "Next Rebase",
        value1 : '00:08:48',
        second : "Average TITANO Holding",
        value2 : "$4,109.43",
        bgColor : "linear-gradient(270deg, rgba(116, 175, 251, 0.66) 0%, rgba(54, 134, 236, 0.66) 100%)"
    },
    
]

export const titanoPriceData =[
    {
        title : "TITANO Price",
        value : "$0.1950",
        share : "+2.59"
    },
    {
        title : "Market Value Of Treasury Assets",
        value : "$0.00",
        share : "-1.00%"
    },
    {
        title : "BNB Liquidity Value",
        value : "$14,974,844.21",
        share : "+19.57%"
    },
    {
        title : "Risk Free Value Market Value",
        value : "$8,739,239.22",
        share : "+19.57%"
    },
]

export const nextRebaseData = [
    {
        id : "1",
        first : "Next Rebase",
        value1 : "23: 39:42",
        second : "APY",
        value2 :"1,000,202.08%"
    },
    {
        id : "2",
        first : "Fully Diluted Value",
        value1 : "$792,251.46",
        second : "APY",
        value2 :"1,000,202.08%"
    },
    {
        id : "3",
        first : "Circulating Supply",
        value1 : "44260",
        second : "Total Supply",
        value2 :"44260"
    },
    
]
export const nofPriceData =[
    {
        title : "NOF Price",
        value:"$17.90",
    },
    {
        title : "Treasury Value",
        value:"$52,503.71",
    },
    {
        title : "LP Value",
        value:"$180,932.69",
    },
    {
        title : "NOF Insurance Fund Value",
        value:"$69,435.78",
    },
]

export const nofIncinatorData = [
    {
        title : "NOF in Incinerator",
        value:"2045"
    },
    {
        title : "$ Value of incinerator",
        value:"$36,605.38"
    },
    {
        title : "Incinerator : Supply Ratio",
        value:"0,046%"
    },
    
]